import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-loginPassword",
  "use": "icon-loginPassword-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"icon-loginPassword\"><g><path d=\"M20,10h-2V7c0-3.3-2.7-6-6-6S6,3.7,6,7v3H4c-1.1,0-2,0.9-2,2v9c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2v-9\n\t\tC22,10.9,21.1,10,20,10z M8,7c0-2.2,1.8-4,4-4c2.2,0,4,1.8,4,4v3H8V7z M20,21H4l0-9h0h16V21z\" /><path d=\"M12,14c-0.6,0-1,0.4-1,1v3c0,0.6,0.4,1,1,1s1-0.4,1-1v-3C13,14.4,12.6,14,12,14z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol